import { useState, useEffect, useCallback } from 'react';
import { onClearDataSearch } from '../services/hookHelpers';
import toast from 'react-hot-toast';
import { TOAST_ERROR_IDS } from '../interaces/toast.ids.interface';
import { formatDataSearch } from '../services/helpers';
import { formatDate } from '../services/helpers';
export const useDataTable = (api = null) => {
  const [entities, setEntities] = useState([]);

  const [loading, setLoading] = useState(false);

  const [searchValue, setSearchValue] = useState('');

  const [shouldClear, setShouldClear] = useState(false);

  const [filters, setFilters] = useState([]);

  const [dataFilters, setDataFilters] = useState([]);

  const [startDate, setStartDate] = useState('');

  const [endDate, setEndDate] = useState('');

  const [pageData, setPageData] = useState({
    page: 1,
    size: 10,
    order:'Desc'//podra ser Asc
  });

  const [dataPagination, setDataPagination] = useState({
    first: true,
    last: false,
    page: 1,
    size: 10,
    totalElements: 10,
    totalPages: 1,
  });
  const fetchSearch = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.search(formatDataSearch(filters, searchValue, pageData));
      fillDataPagination(response);
      return response.data;
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
      return [];
    } finally {
      setLoading(false);
    }
  }, [filters, searchValue, pageData]);
  const onClear = () => {
    onClearDataSearch(setSearchValue, setFilters, setShouldClear, setDataFilters, setPageData);
  };

  useEffect(() => {
    if (shouldClear) {
      fetchSearch();
      setShouldClear(false);
    }
  }, [shouldClear, fetchSearch]);
  useEffect(() => {
    setFilters(
      dataFilters
        .filter((item) => item.value_filter !== '' && item.show != true)

        .map((item) => ({
          filter: item.filter,
          value_filter: item.value_filter,
        }))
    );
    if (startDate && endDate) {
      setFilters((prev) => [
        ...prev,
        {
          filter: 'startDate',
          value_filter: formatDate(startDate),
        },
        {
          filter: 'endDate',
          value_filter: formatDate(endDate),
        },
      ]);
    }
  }, [dataFilters, endDate, startDate]);

  const fillDataPagination = (response) => {
    setDataPagination({
      first: response.first,
      last: response.last,
      page: response.page,
      size: response.size,
      totalElements: response.totalElements,
      totalPages: response.totalPages,
    });
    setEntities(response.data);
  };
  //metodo para filtros
  const [names, setNames] = useState([]);
  const getNames = useCallback(async () => {
    try {
      const response = await api.getNames();
      setNames(response);
    } catch {
      toast.error(TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  }, []);

  return {
    entities,
    setEntities,

    loading,
    setLoading,

    searchValue,
    setSearchValue,

    shouldClear,
    setShouldClear,
    onClear,

    filters,
    setFilters,

    dataFilters,
    setDataFilters,

    startDate,
    setStartDate,

    endDate,
    setEndDate,

    pageData,
    setPageData,

    dataPagination,
    setDataPagination,
    fillDataPagination,
    fetchSearch,
    //filtros
    getNames,
    names,
    setNames,
  };
};
